import React from 'react';
import { Link } from 'react-router-dom';
import { formatCourseThumbnail, handleThumbnailError } from '../../utils/imageUtils';

const CourseCard = ({ 
  course,
  showProgress = false,
  subscriptionStatus = null,
  className = ''
}) => {
  const {
    id,
    _id,
    title,
    thumbnail,
    duration,
    liveClassCount,
    level,
    category,
    progress,
  } = course;

  const courseId = id || _id;

  return (
    <div className={`card overflow-hidden group ${className}`}>
      <div className="relative overflow-hidden aspect-[16/10] bg-dark-100">
        <img
          src={formatCourseThumbnail(thumbnail)}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          onError={handleThumbnailError}
        />
        {category && (
          <span className="absolute top-3 right-3 bg-dark-900/80 text-white text-xs font-medium px-3 py-1 rounded-full">
            {category}
          </span>
        )}
        {subscriptionStatus === 'subscribed' && (
          <span className="absolute top-3 left-3 bg-green-500 text-white text-xs font-semibold px-2.5 py-1 rounded-full flex items-center gap-1">
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" /></svg>
            Enrolled
          </span>
        )}
        {subscriptionStatus === 'not_subscribed' && (
          <span className="absolute top-3 left-3 bg-amber-500 text-white text-xs font-semibold px-2.5 py-1 rounded-full">
            Not Enrolled
          </span>
        )}
      </div>

      <div className="p-5">
        <h3 className="text-lg font-semibold text-dark-900 mb-3 line-clamp-2 group-hover:text-primary-500 transition-colors">
          {title}
        </h3>

        <div className="flex items-center gap-4 text-sm text-dark-400 mb-4">
          {duration && (
            <span className="flex items-center gap-1">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              {duration}
            </span>
          )}
          {liveClassCount > 0 && (
            <span className="flex items-center gap-1">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
              {liveClassCount} class{liveClassCount !== 1 ? 'es' : ''}
            </span>
          )}
          {level && (
            <span className="flex items-center gap-1">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
              {level}
            </span>
          )}
        </div>

        {showProgress && progress !== undefined && (
          <div className="mb-4">
            <div className="flex justify-between text-sm mb-1">
              <span className="text-dark-500">Progress</span>
              <span className="text-primary-500 font-medium">{progress}%</span>
            </div>
            <div className="h-2 bg-dark-100 rounded-full overflow-hidden">
              <div
                className="h-full bg-primary-500 rounded-full transition-all duration-300"
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>
        )}

        <div className="flex items-center justify-end">
          <Link
            to={`/courses/${courseId}`}
            className="text-primary-500 hover:text-primary-600 font-medium text-sm transition-colors"
          >
            {showProgress ? 'Continue' : 'View Course'} →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
